/**
 * Форматирование сумм/дат и роль-классификация для модуля биллинга (#338).
 */
import type { ActorRole } from '../../shared/api/platform-me.js';

/** Гость и прочие consumer-роли (как consumerRoles на бэке). */
const CONSUMER_ROLES = new Set<string>(['guest', 'guest_minor', 'vendor', 'vendor_buyer']);

/**
 * true, если актор — персонал/менеджмент (любая НЕ consumer-роль). Тот же
 * критерий, что у бэкенда (internal/billing/http_app actorIsStaff): гость
 * видит «Мои счета», любой staff/manager/owner/reception — «Все счета».
 */
export function actorIsBillingStaff(roles: readonly ActorRole[]): boolean {
  for (const r of roles) {
    if (!CONSUMER_ROLES.has(r)) return true;
  }
  return false;
}

/** Форматирует денежную сумму с валютой (рубли/др., десятичные). */
export function formatMoney(amount: number, currency = 'RUB', locale = 'ru-RU'): string {
  try {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      maximumFractionDigits: 2,
    }).format(amount);
  } catch {
    return `${amount.toFixed(2)} ${currency}`;
  }
}

/** Короткая дата/время. */
export function formatDateTime(iso: string, locale = 'ru-RU'): string {
  try {
    return new Intl.DateTimeFormat(locale, {
      day: 'numeric',
      month: 'short',
      hour: '2-digit',
      minute: '2-digit',
    }).format(new Date(iso));
  } catch {
    return iso;
  }
}
